export default class Pessoa{
    nome = "";
    razaoSocial = "";
    cpf = "";
    cnpj = "";
    telefone = "";
    estado = "";
    cidade = "";
    tipoEspecifico = "";
    codigo = "";
    funcionarioPrimeseg = false;
}



// WEBPACK FOOTER //
// ./src/model/Pessoa.js